import { IFavorite } from "@/types/menu-types";
import { prefix } from ".";
import MenuItem from "./MenuItem";
import { IShoppingCartInfo } from "@/types/order-types";
import Skeleton from "../Skeleton";

interface IMenuListProps {
  data: IFavorite[];
  isFirst: boolean;
  loading?: boolean;
  showContent?: boolean;
  shoppingCartData: IShoppingCartInfo | undefined;
  handleAddShoppingCart: (favorite: IFavorite) => void;
  handleMinusShoppingCart: (favorite: IFavorite) => void;
  className?: string;
}

const MenuList: React.FC<IMenuListProps> = props => {
  const {
    data,
    isFirst,
    className = '',
    showContent = true,
    shoppingCartData,
    loading = false,
    handleAddShoppingCart,
    handleMinusShoppingCart,
  } = props

  return (
    <div className={`${prefix} ${className} menus ${isFirst ? 'isFirst' : ''} ${(data.length === 0 && !loading) || !showContent ? 'isEmpty' : ''}`}>
      {
        !loading && showContent &&
        data.map(item => (
          <MenuItem
            key={item.id}
            data={item}
            shoppingCartData={shoppingCartData}
            handleMinusShoppingCart={handleMinusShoppingCart}
            handleAddShoppingCart={handleAddShoppingCart}
          />
        ))
      }
      {
        loading &&
        new Array(8).fill('').map((r, i) => (
          <div key={`${r}_${i}`} className={`${prefix}-skeleton`}>
            <Skeleton
              loading={loading}
              row={1}
              className={`${prefix}-skeleton-left`}
              rowWidth={[72]}
              rowHeight={[72]}
            />
            <div className={`${prefix}-skeleton-right`}>
              <Skeleton
                loading={loading}
                row={1}
                rowWidth={['100%']}
              />
              <Skeleton
                loading={loading}
                row={1}
                rowWidth={['60%']}
                rowHeight={[20]}
              />
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default MenuList;